<template>
  <v-container class="d-flex align-self-start" fluid>
    <v-row no-gutters>
      <!--BOTON DE INICIO DE SESION -->
      <v-col cols="12">
        <v-card tile class="pa-1" elevation="0">
          <v-card-title class="display-2 font-weight-black pb-0">
            One Drive
            <v-spacer></v-spacer>
            <v-btn
              color="#0361B2"
              dark
              @click="AutenticarUsuario()"
              v-if="local_storage"
            >
              iniciar sesión con One Drive
            </v-btn>
            <v-btn color="#0361B2" dark @click="cerraSesion()" v-if="false">
              cerrar sesion
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <!--FILE INPUT -->
      <v-col cols="12">
        <v-card tile class="pa-1" elevation="0">
          <v-row no-gutters>
            <v-col
              cols="12"
              md="auto"
              align-self="center"
              class="pa-1"
              v-if="!local_storage"
            >
              <v-text-field
                v-model="nombre_carpeta"
                label="Numero de asistencia"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="3"
              class="pa-1"
              align-self="center"
              v-if="!local_storage"
            >
              <v-file-input
                v-model="file_input"
                label="Cargar Archivos"
                multiple
                hide-details
                outlined
                dense
              ></v-file-input>
            </v-col>
            <v-col
              cols="12"
              md="auto"
              class="pa-2"
              align-self="center"
              v-if="!local_storage && poder_cargar"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    @click="guardarArchivos()"
                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon large> fas fa-cloud-upload-alt </v-icon>
                  </v-btn>
                </template>
                <span>Guardar</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="py-1">
              <div class="title">Detalles</div>
            </v-col>
            <v-col cols="12" md="auto" class="py-1">
              <v-text-field
                v-model="marca"
                label="marca"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto" class="py-1">
              <v-text-field
                v-model="modelo"
                label="modelo"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto" class="py-1">
              <v-text-field
                v-model="placa"
                label="placa"
                outlined
                hide-details
                dense
                disabled
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
        <v-divider></v-divider>
      </v-col>

      <!-- BUSQUEDA -->
      <v-col cols="12">
        <v-card tile class="pa-1" elevation="0">
          <v-row>
            <v-col cols="12" md="2" align-self="center">
              <v-text-field
                v-model="archivos_busqueda"
                label="Numero de asistencia"
                outlined
                dense
                hide-details
                disabled
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="auto">
              <v-btn color="primary" @click="establecerRuta()"
                >Ver archivos</v-btn
              >
            </v-col>
            <v-col cols="auto" align-self="center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    :disabled="items_seleccionados.length == 0"
                    @click="descargarArchivo()"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon large> fas fa-cloud-download-alt </v-icon></v-btn
                  >
                </template>
                <span>Descargar</span>
              </v-tooltip>
            </v-col>
            <v-col cols="12" md="3" align-self="center" v-if="poder_eliminar">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    :disabled="items_seleccionados.length == 0"
                    @click="opcionEliminarSeleccionados()"
                    icon
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon large> fas fa-trash-alt </v-icon></v-btn
                  >
                </template>
                <span>Eliminar seleccionados</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!--DATA TABLE -->
      <v-col cols="12">
        <v-data-table
          v-model="items_seleccionados"
          :items="items_archivos"
          :headers="headers_archivos"
          fixed-header
          class="elevation-1 mx-1"
          item-key="id"
          show-select
          disable-pagination
        >
          <template v-slot:[`item.lastModifiedDateTime`]="{ item }">
            <span>
              {{ formatoFecha(item.lastModifiedDateTime) }}
            </span>
          </template>
          <template v-slot:[`item.action_view`]="{ item }">
            <v-icon class="mr-2" color="blue" @click="vistaPrevia(item)">
              fa-regular fa-folder-open
            </v-icon>
          </template>
          <template
            v-slot:[`item.delete`]="{ item }"
            v-if="
              $store.state.usuario.idUsuario == 1 ||
              $store.state.usuario.idUsuario == 7
            "
          >
            <v-icon @click="opcionEliminar(item)">fas fa-trash-alt</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_preview" width="800">
      <v-card tile>
        <v-card-title></v-card-title>
        <v-card-text>
          <v-img :src="url_preview"></v-img>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_progress" width="300" persistent>
      <v-progress-linear
        color="blue darken-4"
        indeterminate
        rounded
        height="10"
      >
      </v-progress-linear>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbar_color" bottom>{{
      mensaje_snackbar
    }}</v-snackbar>

    <v-dialog v-model="dialog_progress_linear" width="300" persistent>
      <v-card>
        <v-progress-linear
          indeterminate
          height="6"
          color="blue"
          stream
          rounded
          striped
        >
        </v-progress-linear>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog_status_files"
      v-if="archivos_subidos != ''"
      width="500"
    >
      <v-list dense elevation="2">
        <v-subheader class="title black--text"
          >ESTATUS DE ARCHIVOS CARGADOS</v-subheader
        >
        <v-divider></v-divider>

        <v-list-item v-if="cont_pdf > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_pdf }} archivo(s) pdf
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_docx > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_docx }} archivo(s) doc, docx
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_jpg > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_jpg }} archivo(s) jpg, jpeg
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_mp3 > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_mp3 }} archivo(s) mp3
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_mp4 > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_mp4 }} archivo(s) mp4
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_png > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_png }} archivo(s) png
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_pptx > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_pptx }} archivo(s) pptx
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_txt > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_txt }} archivo(s) txt
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_xlsx > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_xlsx }} archivo(s) xlsx
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_zip > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_zip }} archivo(s) zip
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_rar > 0">
          <v-list-item-icon>
            <v-icon>fas fa-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_rar }} archivo(s) rar
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="cont_error > 0">
          <v-list-item-icon>
            <v-icon>fas fa-times</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ cont_rar }} archivo(s) no se cargaron
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-subheader class="title black--text">
          {{ archivos_subidos.length }} Archivos
        </v-subheader>
        <v-divider></v-divider>
        <v-list-item-action>
          <v-btn @click="limpiarVariables()" text>Cerrar</v-btn>
        </v-list-item-action>
      </v-list>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar" width="500" persistent>
      <v-card :loading="loading_dialog_eliminar">
        <v-card-title>Desea eliminar este archivo?</v-card-title>
        <v-card-text>
          <v-text-field v-model="nombre_archivo" readonly></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarArchivo()">Eliminar</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_eliminar_seleccionados" width="500" persistent>
      <v-card>
        <v-card-title
          >Desea eliminar los {{ items_seleccionados.length }} archivos
          seleccionados?</v-card-title
        >
        <v-card-actions>
          <v-btn color="red" dark @click="eliminarArchivosSeleccionados()"
            >Eliminar seleccionados</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="dialog_eliminar = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import one_drive_api from "../view/OneDriveApi";
import moment from "moment";

export default {
  data() {
    return {
      items_archivos: [],
      headers_archivos: [
        { text: "Nombre", value: "name" },
        { text: "Fecha última modificación", value: "lastModifiedDateTime" },
        {
          text: "Ver archivo",
          value: "action_view",
          align: "center",
          sortable: false,
        },
        {
          text: "Descargar",
          value: "selected",
          align: "center",
          sortable: false,
        },
        {
          text: "Eliminar",
          value: "delete",
          align: "center",
          sortable: false,
        },
      ],
      items_seleccionados: [],
      snackbar: false,
      mensaje_snackbar: null,
      file_input: [],
      dialog_preview: false,
      dialog_file_preview: false,
      nombre_nuevo_folder: null,
      snackbar_color: "primary",
      local_storage: true,
      result_one_drive: [],
      archivos_busqueda: "",
      meses: [
        "ENERO",
        "FEBRERO",
        "MARZO",
        "ABRIL",
        "MAYO",
        "JUNIO",
        "JULIO",
        "AGOSTO",
        "SEPTIEMBRE",
        "OCTUBRE",
        "NOVIEMBRE",
        "DICIEMBRE",
      ],
      nombre_carpeta: "",
      url_preview: "",
      dialog_progress: false,
      item_asistencia: "",
      marca: "",
      modelo: "",
      placa: "",
      id_drive_llaves_access_token: 0,
      id_drive_llaves_expires_in: 0,
      dialog_progress_linear: false,
      dialog_status_files: true,
      archivos_subidos: [],
      cont_pdf: 0,
      cont_docx: 0,
      cont_jpg: 0,
      cont_mp3: 0,
      cont_mp4: 0,
      cont_png: 0,
      cont_pptx: 0,
      cont_txt: 0,
      cont_xlsx: 0,
      cont_zip: 0,
      cont_rar: 0,
      cont_error: 0,
      // redirect_uri: "http://localhost:8080/authGoogleDrive",
      redirect_uri: "https://asistenciaregional.com/authGoogleDrive",
      dialog_eliminar: false,
      loading_dialog_eliminar: false,
      dialog_eliminar_seleccionados: false,
      nombre_archivo: "",
      id_archivo: 0,
      acciones: [],
      poder_cargar: false,
      poder_eliminar: false,
      access_token: "",
      interval: null,
    };
  },
  created() {
    this.listarCredenciales();
    this.listarAsistencia();
    this.listarAcciones();
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  methods: {
    listarAcciones() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/accionesXroles/Listar/" + this.$store.state.usuario.idRol,
          configuracion
        )
        .then((response) => {
          //console.log(response.data);
          var item_del = response.data.find(
            (object) => object.nombre_acciones == "Eliminar archivo"
          );
          var item_upl = response.data.find(
            (object) => object.nombre_acciones == "Cargar archivo"
          );
          if (item_del.estatus) {
            this.poder_eliminar = true;
          }
          if (item_upl.estatus) {
            this.poder_cargar = true;
          }
        });
    },
    listarAsistencia() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      axios
        .get(
          "api/Cabinas/MostrarCodigoNumAsistencia/" + this.$route.params.id,
          configuracion
        )
        .then((response) => {
          this.item_asistencia = response.data;
          this.nombre_carpeta = response.data.numeroAsistencia;
          this.marca = response.data.marca;
          this.modelo = response.data.modelo;
          this.placa = response.data.placa;
          this.archivos_busqueda = response.data.numeroAsistencia;
        });
    },
    async listarCredenciales() {
      this.interval = setInterval(async () => {
        var credenciales_drive = await one_drive_api.listarCredencialesOneDrive(
          this.$store.state.usuario.idUsuario
        );

        var response = await axios.post("api/Usuarios/ObtenerNuevoToken", {
          refresh_token: credenciales_drive[0].valor,
          redirect_uri: process.env.VUE_APP_URL_REDIRECTION,
        });
        this.access_token = response.data.access_token;

        if (credenciales_drive) {
          localStorage.setItem("credentials", "si");
          this.flag_credenciales();
          clearInterval(this.interval);
        }
      }, 1000);
    },
    AutenticarUsuario() {
      one_drive_api.AuthUsuario();
    },
    establecerRuta() {
      this.items_seleccionados = [];

      let cartera = this.item_asistencia.cartera;
      let mes =
        this.meses[
          parseInt(this.item_asistencia.fechaHoraActual.split("-")[1]) - 1
        ];
      let anio = parseInt(this.item_asistencia.fechaHoraActual.split("-")[0]);

      this.verArchivos(cartera + "/" + anio + "/" + mes);
    },
    async verArchivos(ruta) {
      //this.dialog_progress_linear = true;
      //let ruta = "ASEGURADORAS/FUTURO ASISTENCIA/2022/NOVIEMBRE/NUMEROASISTENCIA";
      let path = "ASEGURADORAS/" + ruta + "/" + this.archivos_busqueda;

      let result = await one_drive_api.verListaCarpetas(
        this.$store.state.usuario.idUsuario,
        path
      );

      if (result == "Not Found") {
        this.dialog_progress_linear = false;
        this.alerta("No se encontraron archivos", "info");
      } else {
        this.items_archivos = result;
        this.dialog_progress_linear = false;
      }
    },
    async guardarArchivos() {
      if (this.file_input.length <= 0) {
        return;
      }
      this.dialog_progress_linear = true;

      let cartera = this.item_asistencia.cartera;
      let anio = parseInt(this.item_asistencia.fechaHoraActual.split("-")[0]);
      let nombre_mes =
        this.meses[
          parseInt(this.item_asistencia.fechaHoraActual.split("-")[1]) - 1
        ];
      let nombre_carpeta = this.item_asistencia.numeroAsistencia;
      let ruta = cartera + "/" + anio + "/" + nombre_mes + "/" + nombre_carpeta;

      this.file_input.forEach(async (element) => {
        this.crearArchivo(ruta, element);
      });
    },
    async vistaPrevia(item) {
      this.dialog_progress_linear = true;

      var type_video = item.file.mimeType.split("/")[0];
      if (type_video == "video") {
        var result = await one_drive_api.linkPermiso(
          this.$store.state.usuario.idUsuario,
          item.id
        );
        window.open(result.data.link.webUrl, "_blank");
      } else {
        var result = await one_drive_api.vistaPreviaImg(
          this.$store.state.usuario.idUsuario,
          item.id
        );
        this.url_preview = result;
        this.dialog_preview = true;
      }
      this.dialog_progress_linear = false;
    },
    async descargarArchivo() {
      this.dialog_progress_linear = true;

      one_drive_api.descargarArchivo(
        this.$store.state.usuario.idUsuario,
        this.items_seleccionados
      );
      this.dialog_progress_linear = false;
    },
    opcionEliminar(item) {
      this.dialog_eliminar = true;
      this.id_archivo = item.id;
      this.nombre_archivo = item.name;
    },
    async eliminarArchivo() {
      this.loading_dialog_eliminar = true;
      const result = await one_drive_api.eliminarArchivo(
        this.$store.state.usuario.idUsuario,
        this.id_archivo
      );
      if (result == 204) {
        this.dialog_eliminar = false;
        this.loading_dialog_eliminar = false;
        this.alerta("Archivo eliminado", "success");
        this.establecerRuta();
      } else {
        this.dialog_eliminar = false;
        this.loading_dialog_eliminar = false;
        this.alerta("No se pudo eliminar el archivos");
        this.establecerRuta();
      }
    },
    opcionEliminarSeleccionados() {
      this.dialog_eliminar_seleccionados = true;
    },
    eliminarArchivosSeleccionados() {
      this.items_seleccionados.forEach(async (element) => {
        const result = await one_drive_api.eliminarArchivo(
          this.$store.state.usuario.idUsuario,
          element.id
        );
      });

      this.dialog_eliminar_seleccionados = false;
      this.alerta("Archivos eliminados", "success");
      this.establecerRuta();
    },
    //GUARDAR ARCHIVOS DE TAMAÑO GRNADE
    async crearArchivo(ruta, archivo) {
      let header = {
        Authorization: "Bearer " + this.access_token,
        "Content-Type": "application/json",
      };
      let configuracion = { headers: header };

      await axios
        .post(
          "https://graph.microsoft.com/v1.0/me/drive/root:/ASEGURADORAS/" +
            ruta +
            "/" +
            archivo.name +
            ":/createUploadSession",
          {},
          configuracion
        )
        .then(async (response) => {
          this.uploadFile(response.data.uploadUrl, archivo);
        });
    },
    uploadFile(uploadUrl, archivo) {
      let me = this;
      const async = require("async");

      async.eachSeries(this.getparams(archivo), function (st, callback) {
        setTimeout(async function () {
          let header = {
            "Content-Length": st.clen,
            "Content-Range": st.cr,
          };
          let configuracion = { headers: header };
          let response = await axios.put(uploadUrl, archivo, configuracion);

          me.dialog_progress_linear = false;
          if (response.status == 201) {
            me.estatusArchivosCargados(response.data.name);
            me.archivos_subidos.push({
              icon: "fas fa-check",
              name: response.data.name,
            });
          } else {
            me.estatusArchivosCargados("archivo.error");
            me.archivos_subidos.push({
              icon: "fas fa-times",
              name: "No se pudo cargar archivo: " + response.data.name,
            });
          }
          callback();
        }, st.stime);
      });
    },
    getparams(file) {
      var allsize = file.size;
      var sep = allsize < 60 * 1024 * 1024 ? allsize : 60 * 1024 * 1024 - 1;
      var ar = [];
      for (var i = 0; i < allsize; i += sep) {
        var bstart = i;
        var bend = i + sep - 1 < allsize ? i + sep - 1 : allsize - 1;
        var cr = "bytes " + bstart + "-" + bend + "/" + allsize;
        var clen = bend != allsize - 1 ? sep : allsize - i;
        var stime = allsize < 60 * 1024 * 1024 ? 5000 : 10000;
        ar.push({
          bstart: bstart,
          bend: bend,
          cr: cr,
          clen: clen,
          stime: stime,
        });
      }
      return ar;
    },
    estatusArchivosCargados(item) {
      let lista_caracteres = item.split(".");
      let tipo_archivo = lista_caracteres[lista_caracteres.length - 1];

      switch (tipo_archivo) {
        case "pdf":
          this.cont_pdf++;
          break;
        case "docx":
        case "doc":
          this.cont_docx++;
          break;
        case "jpeg":
        case "jpg":
          this.cont_jpg++;
          break;
        case "mp3":
          this.cont_mp3++;
          break;
        case "mp4":
          this.cont_mp4++;
          break;
        case "png":
          this.cont_png++;
          break;
        case "pptx":
          this.cont_pptx++;
          break;
        case "txt":
          this.cont_txt++;
          break;
        case "xls":
        case "xlsx":
          this.cont_xlsx++;
          break;
        case "zip":
          this.cont_zip++;
          break;
        case "rar":
          this.cont_rar++;
          break;
        case "error":
          this.cont_error++;
          break;
      }
    },
    limpiarVariables() {
      this.dialog_status_files = false;
      this.file_input = [];
      this.cont_docx = 0;
      this.cont_error = 0;
      this.cont_jpg = 0;
      this.cont_mp3 = 0;
      this.cont_mp4 = 0;
      this.cont_pdf = 0;
      this.cont_png = 0;
      this.cont_pptx = 0;
      this.cont_rar = 0;
      this.cont_txt = 0;
      this.cont_xlsx = 0;
      this.cont_zip = 0;
    },
    ////////////////////////////////////////////////////////////////////////////
    async obtenerNuevoToken(refresh_token) {
      await axios
        .post("api/Usuarios/ObtenerNuevoToken", {
          refresh_token: this.desencriptarDato(refresh_token),
          redirect_uri: this.redirect_uri,
        })
        .then(async (response) => {
          await this.guardarNuevasCredenciales(response.data.access_token);
        });

      return;
    },
    async guardarNuevasCredenciales(data) {
      await Promise.all([
        await this.guardarNuevoAccessToken(data),
        await this.guardarNuevoExpiresIn(),
      ]);
    },
    async guardarNuevoAccessToken(token) {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      await axios
        .put(
          "api/DriveLlaves/Actualizar",
          {
            id_drive_llaves: parseInt(this.id_drive_llaves_access_token),
            idUsuario: parseInt(this.$store.state.usuario.idUsuario),
            clave: "access_token",
            valor: this.encriptarDato(token),
          },
          configuracion
        )
        .then(() => {
          console.log("guardado nuevo access_token");
        });
    },
    async guardarNuevoExpiresIn() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      await axios
        .put(
          "api/DriveLlaves/Actualizar",
          {
            id_drive_llaves: parseInt(this.id_drive_llaves_expires_in),
            idUsuario: parseInt(this.$store.state.usuario.idUsuario),
            clave: "expires_in",
            valor: new Date().getTime() + 1 * 60 * 60 * 1000,
          },
          configuracion
        )
        .then(() => {
          console.log("guardado nuevo expires_in");
        });
    },
    ////////////////////////////////////////////////////////////////////////////
    encriptarDato(data) {
      var CryptoJS = require("crypto-js");
      var ciphertext = CryptoJS.AES.encrypt(data, "R3gi0n@l_2@22").toString();
      return ciphertext;
    },
    desencriptarDato(data) {
      var CryptoJS = require("crypto-js");
      var bytes = CryptoJS.AES.decrypt(data, "R3gi0n@l_2@22");
      return bytes.toString(CryptoJS.enc.Utf8);
    },
    formatoFecha(fecha) {
      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");
    },
    formatoFechaV2(fecha) {
      return moment(fecha).format("DD-MM-YYYY");
    },
    flag_credenciales() {
      if (localStorage.getItem("credentials")) {
        this.local_storage = false;
      } else {
        this.local_storage = true;
      }
    },
    getLlave(clave, credenciales = []) {
      for (var i = 0; i < credenciales.length; i++) {
        if (credenciales[i]["clave"] == clave) {
          return credenciales[i];
        }
      }
    },
    alerta(mensaje, icono) {
      this.$swal({
        toast: true,
        position: "top-end",
        title: mensaje,
        icon: icono,
        showConfirmButton: false,
        timer: 5000,
        backdrop: false,
      });
    },
  },
};
</script>